import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Flow45_2Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Flow45_2 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("LOSSES_FOR_EVERYTHING_IN_CATEGORY") || "Losses for everything in this category"}
        subDescription={t("LOSSES_FOR_EVERYTHING_IN_CATEGORY_DESC") || "This is where you record any losses in this category relating to water, packaging and product components."}
        isNormal={true}
        number={"45.2"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`flow-45-2-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Flow45_2Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Flow45_2;

